import { useQueries } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

const route = '/admin/licensed-establishments/corporate-accounts'

export const useGetLicensedEstablishmentsByCorporateAccountIds = ({
  corporateAccountIds,
  enabled = true,
}: {
  corporateAccountIds: number[]
  enabled?: boolean
}) => {
  const get = useTypedApiClient({
    path: route,
    method: 'get',
  })

  return useQueries({
    queries: corporateAccountIds.map((corporateAccountId) => ({
      queryKey: ['licensed-establishments', corporateAccountId],
      queryFn: async () => {
        const queryResult = await get({
          corporateAccountId: [corporateAccountId],
        })
        return queryResult.data
      },
      enabled,
    })),
  })
}
